import { StoreState } from '../types';

export const selectLocations = (state: StoreState) => state.location.locations;
